// B1 (Blok 1, 2026-05-15) — TanStack Query wrapper around
// /api/projects/:projectId/uninvoiced-hours. Pattern mirrors
// `useProjectPackageStatus`: gated by `!!projectId && enabled` so the
// card can hide itself for SLA Hour Package projects without firing a request.

import { useQuery } from '@tanstack/react-query';
import {
  fetchProjectUninvoicedHours,
  type ProjectUninvoicedHoursSummary,
} from '../services/api/projectUninvoicedHours';

export type {
  ProjectUninvoicedHoursSummary,
  MonthlyUninvoicedBucket,
} from '../services/api/projectUninvoicedHours';

// Petra staging UAT 2026-05-18 — after logging entries on /time the
// project detail card lagged because TanStack Query treated 60s-old data
// as fresh. Drop staleTime to 10s, refetch on mount, refetch on tab focus
// so navigating back to /projects/:id pulls the latest figures without a
// manual browser refresh. refetchInterval stays at 5 min for the
// "tab left open" case.
export function useProjectUninvoicedHours(
  projectId: number | undefined,
  enabled = true,
) {
  return useQuery<{ data: ProjectUninvoicedHoursSummary }>({
    queryKey: ['projectUninvoicedHours', projectId],
    queryFn: () => fetchProjectUninvoicedHours(projectId!),
    enabled: !!projectId && enabled,
    staleTime: 10_000,
    refetchInterval: 5 * 60_000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
